export type SignalIcon =
  | 'role'
  | 'response'
  | 'association'
  | 'explored'
  | 'completion'
  | 'cta'
  | 'depth'

export interface Signal {
  id: SignalIcon
  label: string
  detail: string
}

export const signals: Signal[] = [
  {
    id: 'role',
    label: 'Sibling role selected',
    detail: 'Where they place themselves in their own family.',
  },
  {
    id: 'response',
    label: 'Responses to the personality questions',
    detail: 'Whether the stereotype lands — or gets rejected.',
  },
  {
    id: 'association',
    label: 'Product / sibling associations',
    detail: 'Which personality they match to each product.',
  },
  {
    id: 'explored',
    label: 'Products explored',
    detail: 'Which members of the family they spend time with.',
  },
  {
    id: 'completion',
    label: 'Journey completion',
    detail: 'How far through the story they stay.',
  },
  {
    id: 'cta',
    label: 'CTA engagement',
    detail: 'Who acts at the end, and on what.',
  },
  {
    id: 'depth',
    label: 'Interest in deeper Filtek content',
    detail: 'Appetite for the wider Filtek Family story.',
  },
]

export const signalsClosing =
  'The Snak shows not only what clinicians viewed, but how they interacted with the idea.'
